import { useGetPairMaxTpRatios } from '@ui/services/contract/hooks/TradingConfigFacet/useGetPairMaxTpRatios/useGetPairMaxTpRatios';
import { getMaxTpRatios } from '@ui/utils/trade/getMaxTpRatios';
import { getTakeProfitStopLossPrice } from '@ui/utils/trade/getTakeProfitStopLossPrice';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';
import { Address } from 'viem';

import { useGetMaxTakeProfitP } from './useGetMaxTakeProfitP';

export const useGetTargetMaxTpRatios = (
  pairBase: Address,
  leverage: number | undefined,
) => {
  const { data: currentPairMaxTpRatios } = useGetPairMaxTpRatios({
    pairBase: pairBase,
  });

  const maxTakeProfitP = useGetMaxTakeProfitP();

  return useMemo(() => {
    if (
      isNil(currentPairMaxTpRatios) ||
      isNil(maxTakeProfitP) ||
      isNil(leverage)
    )
      return undefined;

    return getMaxTpRatios({
      leverage,
      currentPairMaxTpRatios,
      maxTakeProfitP,
    });
  }, [currentPairMaxTpRatios, leverage, maxTakeProfitP]);
};

export const useGetTargetMaxTpRatiosPrice = ({
  pairBase,
  leverage,
  marketPrice,
  isLong,
  spreadPercentage,
}: {
  pairBase: Address;
  leverage: number | undefined;
  marketPrice: number | undefined;
  isLong: boolean;
  spreadPercentage: number;
}) => {
  const maxTpRatios = useGetTargetMaxTpRatios(pairBase, leverage);

  return useMemo(() => {
    if (isNil(marketPrice) || isNil(maxTpRatios) || isNil(leverage))
      return undefined;

    return getTakeProfitStopLossPrice({
      pnlRate: maxTpRatios,
      isTakeProfit: true,
      entryPrice: marketPrice,
      leverage,
      isLong,
      spreadPercentage: spreadPercentage,
    });
  }, [isLong, leverage, marketPrice, maxTpRatios, spreadPercentage]);
};
